import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import news from "./New.module.css";
import Nav from "../Navbar/Nav";
import Footer from "../Footer/Footer";
import ImgII from '../../img/1mg18.png'

const News = () => {
    const { id } = useParams(); // Get ID from URL
    console.log("🔹 Extracted ID from URL:", id); // ✅ Debugging ID

    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                console.log("⏳ Fetching data...");
                const response = await fetch("http://api.techpressionupdate.com/posts/all");

                if (!response.ok) {
                    throw new Error(`HTTP Error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("🟢 API Response:", result); // ✅ Log entire API response

                // 🔍 Find post by `_id` (Convert both to string for safety)
                const foundPost = result?.data?.posts?.find((p) => String(p._id) === String(id));
                console.log("🔍 Found Post:", foundPost); // ✅ Debugging post search

                if (foundPost) {
                    setPost(foundPost);
                } else {
                    console.warn("⚠️ Post not found!");
                    setPost(null); // Ensure state updates correctly
                }
            } catch (error) {
                console.error("❌ Error fetching post:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [id]);

    return (
        <div>
            <Nav />
            <div className={news.news}>
                <div className={news.container}>
                    <h1>News</h1>

                    {loading ? (
                        <p>Loading...</p>
                    ) : post ? (
                        <div className={news.flex}>
                           <div className={news.imgI}>
                            <img src={ImgII} alt="" />
                          </div>
                            <h1>{post.title}</h1>
                            <p>{post.description}</p>
                            <p>{post.author.name}</p>
                            <p>{post.author.email}</p>
                        </div>
                    ) : (
                        <p>❌ Post not found.</p>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default News;
